<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="600px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        depressed
        v-bind="attrs"
        class="mb-2 mr-2"
        v-on="on"
        @click="getAncestorProcess"
      >
        {{ $t('eDocInternal.viewInstructionRecord') }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>{{ $t('eDocInternal.sentReceiveInstructionRecord') }}</v-card-title>
      <v-divider />
      <v-skeleton-loader
        v-if="pageLoading"
        type="list-item-avatar-two-line, divider, list-item-avatar-two-line"
      />
      <div
        v-if="!pageLoading"
        class="pa-2"
      >
        <v-simple-table>
          <tbody>
            <tr
              v-for="item in ancestorProcess"
              :key="`ancestor${item.id}`"
            >
              <td class="pr-0">
                {{ momentWithHyphen(item.createdTime).format('YYYY-MM-DD HH:mm') }}
              </td>
              <td
                class="pr-0"
                style="min-width: 80px;"
              >
                <v-tooltip
                  top
                  color="black"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                    >{{ showSenderOrGroupName(item) }}</span>
                  </template>
                  <span>{{ showSenderEuidOrGroupAbbr(item) }}</span>
                </v-tooltip>
              </td>
              <td class="pr-0">
                {{ item.senderInstruction }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
      <v-card-actions style="overflow-y: hidden">
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
        <v-spacer />
        <v-btn
          depressed
          @click="genFlowPdf(processId, inflowStatus, redirectPath)"
        >
          {{ $t('eDocInternal.createFlowRecord') }}
        </v-btn>
        <v-btn
          :loading="genPdfBtnLoading"
          depressed
          class="mr-l2"
          @click="genInstructionPdfAndBuildIdLink(processId, inflowStatus, redirectPath)"
        >
          {{ $t('eDocInternal.createInstructionRecord') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { momentWithHyphen } from '@/utils/datetimeUtil'
// import docFlowApi from '@/api/eDocInternal/docFlow'
// import { mdiArrowLeft, mdiArrowDownBoldOutline } from '@mdi/js'
import { docFlowMethod } from '@/mixins/docFlowMethod'
import { mapState } from 'vuex'
import { docFlowModule } from '@/store/moduleName'
import docFlowApi from '@/api/eDocInternal/docFlow'
import { getStorage } from '@/utils/storageUtil'
import signHelper from '@/helper/signHelper'
import { ID_SIGN_AND_DOWNLOAD_PDF_CB_URL } from '@/constant/constant'
import idApi from '@/api/esign/identification'

export default {
  mixins: [docFlowMethod],
  props: {
    processId: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
    //   mdiArrowDownBoldOutline: mdiArrowDownBoldOutline,
    //   mdiArrowLeft: mdiArrowLeft,
      dialog: false,
      ancestorProcess: [],
      pageLoading: false,
      redirectPath: null,
      genFlowPdfBtnLoading: false,
      genPdfBtnLoading: false
    }
  },
  computed: {
    ...mapState(docFlowModule, {
      inflowStatus: state => state.inflowStatus
      // redirectPath: state => state.redirectPath
    })
  },
  created () {
    // this.getProcessLeaf(this.processId)
    this.redirectPath = getStorage(signHelper.REDIRECT_PATH)
  },
  methods: {
    async getAncestorProcess () {
      this.pageLoading = true
      await docFlowApi.getAncestorProcess(this.processId, this.inflowStatus, resp => {
        this.ancestorProcess = resp.data.reverse()
      })
      this.pageLoading = false
    },

    genFlowPdf (processId, inflowStatus, redirectPath) {
      this.genFlowPdfBtnLoading = true
      // console.log('genFlowPdf : ' + processId)
      console.log('genFlowPdf : ' + processId + ', inflowStatus : ' + inflowStatus)
      docFlowApi.genFlowPdf(processId, inflowStatus, redirectPath, resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'docFlowProcess.pdf')
          link.click()
          window.URL.revokeObjectURL(url)
        }
        this.genFlowPdfBtnLoading = false
      })
    },

    genInstructionPdfAndBuildIdLink (processId, inflowStatus, redirectPath) {
      this.genPdfBtnLoading = true
      let finalForm = {
        inflowStatusCodes: inflowStatus,
        processId: processId,
        redirectUrl: ID_SIGN_AND_DOWNLOAD_PDF_CB_URL
      }
      let signObj = {}
      signObj[signHelper.GET_SIGN_LINK_URL] = docFlowApi.genInstructionPdfAndBuildIdLinkUrl
      signObj[signHelper.SIGN_AND_START_WORKFLOW_URL] = idApi.extSignUrl
      signObj[signHelper.REDIRECT_PATH] = redirectPath
      signObj[signHelper.POST_FORM] = finalForm
      signObj[signHelper.SUCCESS_MSG_KEY] = 'TrainingClient.SaveSuccess'
      signObj[signHelper.FAIL_MSG_KEY] = 'TaskList.eSign.FailMessage'

      signHelper.signAndDownloadPdf(signObj)
      setTimeout(() => {
        this.genPdfBtnLoading = false
      }, 10000) // waiting for 10 seconds
    },

    momentWithHyphen
  }
}
</script>
